module.exports = __webpack_public_path__ + "img/logo-full.f49019e7.svg";